import React from 'react'

const TotalRevenueIconRuppee = () => {
    return (
        <>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                version="1.1"
                xmlnsXlink="http://www.w3.org/1999/xlink"
                width={50}
                height={50}
                x={0}
                y={0}
                viewBox="0 0 64 64"
                style={{ enableBackground: "new 0 0 512 512" }}
                xmlSpace="preserve"
                className=""
            >
                <g>
                    <linearGradient
                        id="a"
                        x1={4}
                        x2={60}
                        y1={32}
                        y2={32}
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop offset={0} stopColor="#9cffac" />
                        <stop offset={1} stopColor="#00b59c" />
                    </linearGradient>
                    <path
                        fill="url(#a)"
                        d="M59.997 19.995c.17-8.591-7.42-16.162-15.999-15.992-14.15-.03-21.349 17.352-11.31 27.303 9.96 10.05 27.34 2.84 27.31-11.311zm-21.619-1.28c-1.312-.019-1.318-1.981 0-2h6.32c-.42-1.28-1.62-2.221-3.04-2.221h-3.28c-.56 0-1-.45-1-1s.44-1 1-1h11.24c1.313.021 1.318 1.978 0 2h-3.89c.51.64.88 1.39 1.04 2.22h2.85c1.312.02 1.318 1.98 0 2h-2.85c-.482 2.648-3.01 4.46-5.73 4.22l5.49 4.811c.987.849-.327 2.37-1.31 1.5l-7.5-6.56c-.705-.562-.233-1.78.66-1.75h3.28c1.42 0 2.62-.94 3.04-2.22h-6.32zM13.25 32.995H5c-.55 0-1 .45-1 1v20.922c0 .55.45 1 1 1h8.25c.56 0 1-.45 1-1V33.996c0-.55-.44-1-1-1zm-4.12 7.44c-1.32-.02-1.31-1.98 0-2 1.31.03 1.31 1.98 0 2zM57.743 49.4l-19.437 9.2a14.501 14.501 0 0 1-13.538-.58l-7.719-4.5a1.95 1.95 0 0 0-.8-.27V35.69h6.31c3.06-.202 6.124 2.188 8.568 3.72.5.32 1.09.49 1.69.49h7.269c5.586.02 5.956 7.59.46 7.93h-9.849c-1.316.026-1.31 1.975 0 2h9.849c2.953.046 5.625-2.35 5.919-5.29l8.499-2.47c4.629-1.262 7.09 5.205 2.78 7.33z"
                        opacity={1}
                        data-original="url(#a)"
                        className=""
                    />
                </g>
            </svg>

        </>
    )
}

export default TotalRevenueIconRuppee